


























































import Vue from 'vue';
import store from '@/store';
import { LoadingService, ExtendMixins } from '@/services';
import { EventBus } from '@/event-bus';
import { getContentArea } from '@/contentful';
import { PageBanner, PageSidebar } from '@/components/page-components';
import { InterestRatesResponseModel, InterestRatesDetail, MemberAccountResponseModel } from '@/@types/member';
import { Links } from '@/mixins/link-mixin';
import { FDIC_PLAN } from '@/constants';

interface Data {
  sidebarHeading: string;
  sidebarContent: string;
  accountId: string;
  planType: string;
  custodialAgreementLink: any;
  cashSupplementFDICLink: any;
  cashSuppementLink: any;
  termsAndConditionLink: any;
}

export default ExtendMixins(
    Links,
  ).extend({
  name: 'InterestRates',
  beforeRouteEnter(to, from, next) {
    to.meta.accountId = to.query.accountId;
    to.meta.planType = to.query.planType;
    // REST-025
    LoadingService.watchPromises(store.dispatch('getInterestRates', to.query.planType))
      .then(() => {
        EventBus.$emit('initialLoadDone');
        next();
      });
  },
  beforeMount() {
    getContentArea([
      'hsa-custodial-agreement',
      'hsa-custodial-agreement-supplement-fdic-insured-cash-supplement',
      'hsa-custodial-agreement-supplement-paclife-cash-supplement',
      'terms-and-conditions-investment-accounts',
      'hsa-plan-information-sidebar-header',
    ]).then((data) => {
      const contentAreas = data;
      if (contentAreas) {
        if (contentAreas[0] && contentAreas[0].fields) {
          this.custodialAgreementLink = this.formatSidebarLink(this.parseContentfulLink(contentAreas[0].fields));
        }
        if (contentAreas[1] && contentAreas[1].fields) {
          this.cashSupplementFDICLink = this.formatSidebarLink(this.parseContentfulLink(contentAreas[1].fields));
        }
        if (contentAreas[2] && contentAreas[2].fields) {
          this.cashSuppementLink = this.formatSidebarLink(this.parseContentfulLink(contentAreas[2].fields));
        }
        if (contentAreas[3] && contentAreas[3].fields) {
          this.termsAndConditionLink = this.formatSidebarLink(this.parseContentfulLink(contentAreas[3].fields));
        }
        if (contentAreas[4] && contentAreas[4].fields) {
          this.sidebarHeading = contentAreas[4].fields.textValue;
        }
      }
      this.sidebarContent = [
        this.custodialAgreementLink,
        this.cashSupplementIsFDIC ? this.cashSupplementFDICLink : this.cashSuppementLink,
        this.showTermsAndCondition ? this.termsAndConditionLink : '',
        ].join('');
    });
  },
  data(): Data {
    return {
      sidebarHeading: null,
      sidebarContent: null,
      accountId: this.$route.meta.accountId,
      planType: this.$route.meta.planType,
      custodialAgreementLink: null,
      cashSupplementFDICLink: null,
      cashSuppementLink: null,
      termsAndConditionLink: null,
    };
  },
  methods: {
    formatSidebarLink(link): string {
      return '[' + link.text + ']' + '(' + link.href + ')\n\n';
    },
  },
  computed: {
    account(): MemberAccountResponseModel {
      return this.$store.getters.currentAccount(this.$route.meta.accountId);
    },
    interestRates(): InterestRatesDetail {
      if (this.$store.getters.interestRates) {
        const computedInterestRates = this.$store.getters.interestRates.interestRateTiers;
        const lastInterestRate = computedInterestRates.length - 1;
        computedInterestRates[0].lowLimit = 0;
        computedInterestRates[lastInterestRate].highLimit = '';
        computedInterestRates.forEach((interestRate) => {
          interestRate.lowLimit = this.$options.filters.currency(interestRate.lowLimit);
          interestRate.highLimit = this.$options.filters.currency(interestRate.highLimit);
        });
        return computedInterestRates;
      }
      return;
    },
    planTypeDescription(): InterestRatesResponseModel {
      if (this.$store.getters.interestRates) {
        return this.$store.getters.interestRates.planTypeDescription;
      }
      return;
    },
    showTermsAndCondition(): boolean {
    if (this.$store.getters.userJWT) {
      return this.account.hasInvestmentAccount ? true : false;
    }
    return true;
    },
    cashSupplementIsFDIC(): boolean {
      return this.planType === FDIC_PLAN;
    },
  },
  components: {
    PageBanner,
    PageSidebar,
  },
  });
